import React from 'react';
import Tooltip from '@/components/common/Tooltip';
import { truncate } from '@/modules/TCIUtils';
import { ImageModelType } from './types';
import styles from './ExistingImagePicker.module.scss';

interface ImageModelCardPropTypes {
  imageModel: ImageModelType;
  onSelect: () => void;
  selected: boolean;
}

const MAX_IMAGE_FILE_NAME_LENGTH = 24;

const SELECT_KEYS = ['Enter', ' '];

const ImageModelCard = ({ imageModel, onSelect, selected }: ImageModelCardPropTypes) => (
  <div
    aria-label={imageModel.image.fileName}
    aria-pressed={selected}
    className={`${styles.imageModelCard} ${selected ? styles.selected : ''}`}
    role="button"
    tabIndex={0}
    onClick={onSelect}
    onFocus={onSelect}
    onKeyDown={(e) => {
      if (!SELECT_KEYS.includes(e.key)) return;

      e.preventDefault();
      onSelect();
    }}
  >
    <img
      alt=""
      className={styles.thumbnail}
      src={imageModel.image.smallUrl}
    />

    {imageModel.image.fileName.length > MAX_IMAGE_FILE_NAME_LENGTH ? (
      <Tooltip
        content={<span className="tw-break-words">{imageModel.image.fileName}</span>}
        size="medium"
        theme="white"
      >
        <span>{truncate(imageModel.image.fileName, MAX_IMAGE_FILE_NAME_LENGTH)}</span>
      </Tooltip>
    ) : (
      <span>{imageModel.image.fileName}</span>
    )}
  </div>
);

export default ImageModelCard;
